import { OnInit, Component, ElementRef, ViewChild } from '@angular/core';
// import { NgForm, NgModel } from '@angular/forms';
// import * as $ from "jquery";
import { /* NgbModule,*/ NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationUser } from '../viewmodels/application-user';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
// import { AuthenticationObserver } from '../services/authentication.observer';
import { Global } from '../../app.global';
import { QuestionService } from '../../shared/common/services/question.service';
import { SettingsService } from '../services/settings.service';
import { AdminService } from '../../layouts/services/admin.service';
import { PcnModel } from '../../shared/common/viewmodels/pcn.model';
import { InterfaceService } from '../services/interface.service';
import { productFruits } from 'product-fruits';
import { MessageService } from 'primeng/api';
import { TermsModal } from '../../authentication/services/terms-modal.service';
import { UserEnvironmentService } from '../../shared/common/services/userenvironment.service';
import { StorageService } from '../../shared/common/services/storage.service';
import { UserSettingsService } from '../../shared/common/services/settings.service';

@Component({
  selector: 'app-login-cmp',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [MessageService],
})
export class LoginComponent implements OnInit {
  @ViewChild('tooltip') tooltip: NgbTooltip;
  @ViewChild('tokenInvalid') tokenInvalid: NgbModal;
  @ViewChild('pcnInvalid') pcnInvalid: NgbModal;

  id: string;

  userLogin: ApplicationUser;
  showPassword = false;
  loginErrorMessage = 'some text';
  loadingStatus = false;

  invalidToken = false;
  // invalidPcn = false;
  dataErrors = [];
  tokenData = '';
  isEncryptedData = false;

  isPasswordReset = false;
  resetPasswordTokenData = '';

  isUnlockAccount = false;
  unlockAccountTokenData = '';

  isActivateAccount = false;
  activateAccountTokenData = '';

  // pcn: PcnModel = new PcnModel;

  constructor(
    private element: ElementRef,
    private router: Router,
    private global: Global,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private questionServ: QuestionService,
    private settingsService: SettingsService,
    private adminService: AdminService,
    private route: ActivatedRoute,
    private interfaceServ: InterfaceService,
    private termsModalService: TermsModal,
    private messageService: MessageService,
    private userEnvironmentService: UserEnvironmentService,
    private storageService: StorageService,
    private userSettings: UserSettingsService
  ) {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.route.queryParams.subscribe((params) => {
      // console.log(params);
      if (params['data'] !== undefined) {
        this.isEncryptedData = true;
        this.tokenData = params['data'];
      } else if (params['accountunlocktoken'] !== undefined) {
        this.isUnlockAccount = true;
        this.unlockAccountTokenData = params['accountunlocktoken'];
      } else if (params['resetpasswordtoken'] !== undefined) {
        this.isPasswordReset = true;
        this.resetPasswordTokenData = params['resetpasswordtoken'];
      } else if (params['activateaccount'] !== undefined) {
        this.isActivateAccount = true;
        this.activateAccountTokenData = params['activateaccount'];
      } else if (params['PCN'] !== undefined) {
        this.isEncryptedData = false;
        this.tokenData = JSON.stringify(params);
      }

      if (params['ref'] === 'timeout') {
        setTimeout(() => {
          this.showToast();
        }, 1000);
      }
    });
  }

  ngOnInit(): void {
    this.userLogin = new ApplicationUser();

    // remove screen locks that may be present from a previous session
    this.removeScreenLocks();

    this.storageService.lockPcnPanel(false);
    this.storageService.lockPcnDetails(false);
    this.storageService.lockLetterTop(false);
    this.storageService.lockReasons(false);
    // localStorage.setItem('rm_pcn_panel_locked', 'false');
    // localStorage.setItem('rm_pcn_details_locked', 'false');
    // localStorage.setItem('rm_letter_top_locked', 'false');
    // localStorage.setItem('rm_reasons_locked', 'false');

    // check if we are receiving a reset password link
    if (this.isPasswordReset) {
      this.router.navigate(['/password-reset'], {
        queryParams: { token: this.resetPasswordTokenData },
      });
    } else if (this.isUnlockAccount) {
      this.router.navigate(['/unlock-account'], {
        queryParams: { token: this.unlockAccountTokenData },
      });
    } else if (this.isActivateAccount) {
      this.router.navigate(['/activate-account'], {
        queryParams: { token: this.activateAccountTokenData },
      });
    } else {
      this.validateTokenData();
    }

    this.termsModalService.termsAccepted$.subscribe((accepted) => {
      if (accepted) {
        // this.proceedWithLogin();
      }
    });
  }

  showToast(): void {
    this.messageService.add({
      severity: 'info',
      detail: "You haven't used Response Master for a while, so we've logged you out.",
    });
  }

  validateEncryptedData() {
    // console.log("Validate encrypted data");
    this.interfaceServ.validateEncryptedData(this.tokenData).subscribe((result) => {
      // console.log("Return from validation")
      const errors = Object.entries
        ? Object.entries(result.validationErrors)
        : this.entriesPolyFill(result.validationErrors);
      // console.log("Validation errors:" + errors.length);
      if (errors.length === 0) {
        this.global.tokenPcn = result.pcnDetails;
        if (this.isPcnNotComplete(result.pcnDetails)) {
          this.global.pcnNotComplete = true;
        }
        this.global.isTokenValid = true;
        this.global.isTokenPcnActive = true;
        this.global.encryptedToken = result.token;

        // redirect to welcome screen if user is logged in
        if (
          this.authenticationService.isUserLoggedinAndTokenValid() &&
          result.currentUserUsername.toLowerCase() ===
            this.authenticationService.getCurrentUser().username.toLowerCase()
        ) {
          // console.log("Routing to PCN Details");
          this.router.navigate(['/pcn-details']);
        }
      } else {
        // console.log(errors);
        errors.forEach((error) => {
          // console.log(error[0]);
          // console.log(error[1]);
        });
        this.dataErrors = errors;
      }
    });
  }

  validateTokenData() {
    // clear token
    this.global.isTokenValid = false;
    this.global.isTokenPcnActive = false;
    this.global.encryptedToken = '';
    this.global.questionsAndAnswers = [];
    this.global.touchedQuestionIds.clear();
    this.questionServ.setLocalQuestionsAndAnswers([]);

    if (this.tokenData !== '') {
      if (this.isEncryptedData) {
        // set interface token data
        this.global.interfaceTokenData = this.tokenData;

        // check if the user is logged in, otherwise return
        if (!this.authenticationService.isUserLoggedinAndTokenValid()) {
          return;
        }

        this.validateEncryptedData();
      } else {
        // console.log("Validate SiDem data");
        this.interfaceServ.validateSiDemData(this.id, this.tokenData).subscribe((result) => {
          // console.log("Return from validate");
          // console.log("Token: " + result.token);
          // console.log("PCN: " + result.pcnDetails.pcn);
          // const errors = Object.entries(result.validationErrors);
          const errors = Object.entries
            ? Object.entries(result.validationErrors)
            : this.entriesPolyFill(result.validationErrors);
          // console.log("Errors: " + errors.length);
          if (errors.length === undefined || errors.length === 0) {
            // console.log("No errors from SiDem");
            this.global.tokenPcn = result.pcnDetails;
            if (this.isPcnNotComplete(result.pcnDetails)) {
              this.global.pcnNotComplete = true;
            }
            this.global.isTokenValid = true;
            this.global.isTokenPcnActive = true;
            this.global.encryptedToken = result.token;

            // redirect to welcome screen if user is logged in
            if (
              this.authenticationService.isUserLoggedinAndTokenValid() &&
              result.currentUserUsername.toLowerCase() ===
                this.authenticationService.getCurrentUser().username.toLowerCase()
            ) {
              // console.log("routing to PCN Details");
              this.router.navigate(['/pcn-details']);
            } else {
              // console.log("NOT ROUTING!!!");
            }
          } else {
            // const errors = Object.entries(result.validationErrors);
            const errorsArr = Object.entries
              ? Object.entries(result.validationErrors)
              : this.entriesPolyFill(result.validationErrors);
            // console.log(errors);
            errorsArr.forEach((error) => {
              // console.log(error[0]);
              // console.log(error[1]);
            });
            this.dataErrors = errorsArr;
          }
        });
      }
    }
  }

  entriesPolyFill(obj) {
    const keys = Object.keys(obj);

    const keyValuePairs = keys.map((key) => {
      const value = obj[key];

      return [key, value];
    });

    return keyValuePairs;
  }

  isPcnNotComplete(pcn: PcnModel) {
    return (
      pcn.contravention === null ||
      pcn.selectedActionId === null ||
      pcn.selectedSourceId === null ||
      pcn.selectedStageId === null ||
      pcn.fineNow === null
    );
  }

  isEmptyObject(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  onLoginClick(): void {
    if (this.loadingStatus) {
      return; // Prevent multiple login attempts
    }

    this.tooltip.close();
    this.loadingStatus = true;

    // Extract the domain from the username
    this.global.clientDomain = this.userLogin.username.substring(
      this.userLogin.username.indexOf('@') + 1
    );

    this.authenticationService.login(this.userLogin).subscribe({
      next: (response) => {
        this.loginErrorMessage = response.authenticationFailedReason;

        // Check MFA
        if (response.isMfaRequired) {
          this.userEnvironmentService.getEnvironmentDetails().then((environmentDetails) => {
            // Navigate to MFA component with necessary details
            this.router.navigate(['/mfa'], {
              queryParams: {
                username: response.user.username,
                mfaRequestReason: response.mfaRequestReason,
                ipAddress: environmentDetails.ipAddress,
                deviceFingerprint: environmentDetails.deviceFingerprint,
                email: response.user.redactedEmail,
                country: environmentDetails.country,
                region: environmentDetails.region,
                city: environmentDetails.city,
              },
            });
            this.loadingStatus = false;
            return;
          });
        } else if (response.isAuthenticated) {
          // Check for successful authentication

          // Get the current user
          const currentUser = this.authenticationService.getCurrentUser();
          // Check if terms are accepted
          if (!currentUser.acceptedTerms) {
            // Open the terms modal if not accepted
            this.termsModalService.openModal();
            this.loadingStatus = false;

            // Subscribe to terms acceptance
            this.termsModalService.termsAccepted$.subscribe((accepted) => {
              if (accepted) {
                // Notify the backend about terms acceptance
                this.adminService.updateAcceptedTerms(currentUser.userId, true).subscribe({
                  next: () => {
                    console.log('Accepted terms updated successfully.');

                    // Update the local user state
                    currentUser.acceptedTerms = true;

                    // Proceed with additional setup after terms acceptance
                    this.finalizeLogin(currentUser);
                  },
                  error: (err) => {
                    console.error('Failed to update accepted terms:', err);
                    this.loginErrorMessage = 'Failed to accept terms. Please try again.';
                  },
                });
              }
            });

            return;
          }

          // Proceed with login if terms are already accepted
          this.finalizeLogin(currentUser);
        } else {
          // Handle login failure
          this.tooltip.open();
        }

        this.loadingStatus = false;
      },
      error: (error) => {
        // Handle login error
        this.loginErrorMessage = 'Something went wrong. Please try again.';
        this.tooltip.open();
        this.loadingStatus = false;
      },
    });
  }
  setCookieData() {
    // decision actions
    this.questionServ.getDecisionActions().subscribe({
      next: (result) => {
        if (result) {
          this.questionServ.setLocalDecisionActions(result);
          this.global.decisionActions = result;
        } else {
          // onsole.log('Decision actions are empty.');
        }
      },
      error: (e) => {
        console.log(e);
      },
    });

    // dc: get "non-dynamic" app settings
    this.settingsService.getNonDynamicSettings().subscribe((result) => {
      if (result) {
        this.global.RmOnline = result.rmOnline;
      }
    });

    this.questionServ.getQuestionTypes().subscribe({
      next: (result) => {
        if (result) {
          this.questionServ.setLocalQuestionTypes(result);
          this.global.questionTypes = result;
        } else {
          console.log('Question types are empty.');
        }
      },
      error: (e) => {
        // console.log(e)
      },
    });

    this.questionServ.getQuestionClasses().subscribe({
      next: (result) => {
        if (result) {
          this.questionServ.setLocalQuestionClasses(result);
          this.global.questionClasses = result;
        } else {
          // console.log('Question classes are empty.');
        }
      },
      error: (e) => {
        console.log(e);
      },
    });

    this.setSelectedPoliciesAnswers();
    this.setOffenceTypes();
  }

  setSelectedPoliciesAnswers() {
    this.adminService.getAllPolicies().subscribe((result) => {
      if (result) {
        this.questionServ.setLocalPoliciesAnswers(result);
        this.global.policiesAnswers = result;
      }
    });
  }

  setOffenceTypes() {
    this.adminService.getOffences().subscribe((result) => {
      this.adminService.setLocalOffences(result);
      this.global.offencesTypes = result;
    });
  }

  private finalizeLogin(currentUser: any): void {
    if (this.global.interfaceTokenData !== '' && this.isEncryptedData) {
      this.setCookieData();
      this.tokenData = this.global.interfaceTokenData;
      this.validateEncryptedData();
      return;
    }

    productFruits.init(
      'Jb1L9X2r1htlLKbL',
      'en',
      { username: currentUser.email },
      { disableLocationChangeDetection: false }
    );

    this.removeScreenLocks();

    this.userSettings.getUserSetting('autoPinPcnBlock').subscribe({
      next: (value: any) => {
        this.storageService.lockPcnPanel(value === true);
        this.router.navigate(['/pcn-details']);
        this.setCookieData();
      },
      error: () => {
        this.storageService.lockPcnPanel(false);
        this.router.navigate(['/pcn-details']);
        this.setCookieData();
      },
    });
  }

  private removeScreenLocks() {
    this.storageService.lockReasons(false);
    // localStorage.setItem('rm_reasons_locked', 'false');
    this.storageService.lockPcnPanel(false);
    // localStorage.setItem('rm_pcn_panel_locked', 'false');
    this.storageService.lockPcnDetails(false);
    // localStorage.setItem('rm_pcn_details_locked', 'false');
    this.storageService.lockLetterTop(false);
    // localStorage.setItem('rm_letter_top_locked', 'false');
    this.storageService.lockReasons(false);
  }
}
